import { Pipe, PipeTransform } from '@angular/core';
import { ReserveInStore } from '@features/reserve-in-store/reserve-in-store';

@Pipe({
    name: 'showReservation',
    standalone: true
})
export class ShowReservationPipe implements PipeTransform {
    transform(reservation: ReserveInStore, hasReservationKey?: boolean): boolean {
        if (hasReservationKey) {
            return true;
        }

        return reservation.wasCleared || reservation.items.length !== 0;
    }
}
